export enum DonorMergeStep {
    SelectDonor = 0,
    PreviewMerge = 1
}